<div class="flex w-full flex-col bg-transparent">
  <app-landing-hero
    [heading]="hero.heading"
    [leadSegments]="hero.leadSegments"
    [bodyText]="hero.bodyText"
    [imagePath]="hero.imagePath"
    [imageAlt]="hero.imageAlt"
    [primaryAction]="hero.primaryAction ?? null"
    [secondaryAction]="hero.secondaryAction ?? null"
  />

  <app-landing-feature-section
    id="guesswork"
    [headingId]="guessworkSection.headingId"
    [headingSegments]="guessworkSection.headingSegments"
    [leadText]="guessworkSection.leadText"
    [bodyText]="guessworkSection.bodyText ?? null"
    [carouselImages]="guessworkSection.carouselImages ?? null"
  />

  <div
    id="value-cards"
    aria-labelledby="landing-value-cards-title"
    class="border-b border-teal-500 px-4 pt-8 pb-8 sm:pt-32 sm:pb-32 sm:px-6 lg:px-10"
  >
    <div class="mx-auto w-full max-w-350">
      <h2 id="landing-value-cards-title" class="sr-only">Sentinel value highlights</h2>
      <div class="grid gap-x-7 gap-y-24 pt-16 grid-cols-2 xl:grid-cols-4">
        @for (card of valueCards; track card.title) {
          <app-value-card
            [title]="card.title"
            [subtitle]="card.subtitle"
            [text]="card.text"
            [showIcon]="false"
          />
        }
      </div>
    </div>
  </div>

  <app-landing-feature-section
    id="control-plane"
    [headingId]="controlPlaneSection.headingId"
    [headingSegments]="controlPlaneSection.headingSegments"
    [leadText]="controlPlaneSection.leadText"
    [bodyText]="controlPlaneSection.bodyText ?? null"
    [primaryAction]="controlPlaneSection.primaryAction ?? null"
    [secondaryAction]="controlPlaneSection.secondaryAction ?? null"
    [showTopBorder]="controlPlaneSection.showTopBorder ?? true"
    [showBottomBorder]="controlPlaneSection.showBottomBorder ?? true"
  />

  <div
    id="pricing"
    aria-labelledby="landing-pricing-title"
    class="border-b border-teal-500 bg-surface-dark px-4 pt-8 pb-8 sm:pt-32 sm:pb-32 sm:px-6 lg:px-10"
  >
    <div class="mx-auto w-full max-w-350">
      <div class="flex flex-col items-center text-center">
        <p
          class="w-full max-w-[904px] font-mono text-3xl sm:text-[36px] font-light leading-[47px] tracking-[0.045em] text-teal-500"
        >
          <span>&lt;</span><span class="text-white">plans_and_pricing</span><span>&gt;</span>
        </p>
        <h2
          id="landing-pricing-title"
          class="mt-4 max-w-[752px] text-[36px] font-bold leading-[44px] tracking-[0.005em] text-accent"
        >
          Choose the level of governance you need.
        </h2>
        <p
          class="mt-8 max-w-[540px] text-[24px] font-bold leading-[29px] tracking-[0.005em] text-white"
        >
          Sentinel is available in a free individual tier and paid team plans.
        </p>
      </div>

      <div class="mt-16 grid gap-x-7 gap-y-6 lg:grid-cols-2 xl:grid-cols-3">
        @for (card of pricingCards; track card.planName) {
          <app-pricing-card
            [planName]="card.planName"
            [price]="card.price"
            [pricePrefix]="card.pricePrefix ?? null"
            [priceSuffix]="card.priceSuffix ?? null"
            [features]="card.features"
            [bestFor]="card.bestFor"
            [ctaLabel]="card.ctaLabel"
            [ctaRouterLink]="card.ctaRouterLink ?? null"
            [ctaFragment]="card.ctaFragment ?? null"
          />
        }
      </div>
    </div>
  </div>

  <app-landing-feature-section
    id="ready-to-stop-guessing"
    [headingId]="readyToStopGuessingSection.headingId"
    [headingSegments]="readyToStopGuessingSection.headingSegments"
    [leadText]="readyToStopGuessingSection.leadText"
    [bodyText]="readyToStopGuessingSection.bodyText ?? null"
    [primaryAction]="readyToStopGuessingSection.primaryAction ?? null"
    [secondaryAction]="readyToStopGuessingSection.secondaryAction ?? null"
    [showTopBorder]="readyToStopGuessingSection.showTopBorder ?? true"
    [showBottomBorder]="readyToStopGuessingSection.showBottomBorder ?? true"
    [showVisual]="readyToStopGuessingSection.showVisual ?? true"
  />
</div>
